<div class="dialog-content-container">
  <div class="dialog-header mb-2">
    <img src="assets/images/shield.svg" alt="Seguridad" class="shield-icon" />
    <h3 class="dialog-title">
      Configuración de autenticación por dos factores
    </h3>
  </div>
  <div class="dialog-content">
    <p class="dialog-content-text mb-4">
      Para continuar, primero debemos confirmar su identidad y que es el
      propietario de la cuenta
    </p>
    <button
      pButton
      type="button"
      label="Configurar"
      class="p-button-primary w-full text-sm"
      (click)="onConfigure()"
    ></button>
  </div>
</div>
